<template>
  <v-select
    id="axis-select"
    v-model ="filter.grupoId"
    item-text ="nome"
    item-name ="grupoId"
    item-value ="grupoId"
    :items="groups.grupos"
    label ="Grupo"
    placeholder ="Grupo"
    v-on:change ="$emit('onChange')"
    :disabled = "disabled"
  >
    <template slot="no-data">
      Nenhum Grupo retornado
    </template>
  </v-select>
</template>

<script>
import { groupAPI } from '../GroupAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppGroupCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.loadGroups()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadGroups () {
      this.setLoading(true)
      groupAPI.get(this.filter.municipioId)
        .then(resp => {
          this.groups = resp.data
          this.setLoading(false)
        })
        .catch(this.setLoading(false))
    }
  },
  data () {
    return {
      groups: []
    }
  }
}
</script>
